/* ── Tabla comparativa de la ficha (snippets/ch-compare-table.liquid) ──
   Al tocar un color, la columna cambia a ese producto sin recargar: copia los datos
   de su <template data-cmp-tpl="columna-id"> en las celdas [data-cmp-col][data-f]. */
(function () {
  function swap(root, btn) {
    var key = btn.getAttribute('data-cmp-sw');
    var tpl = root.querySelector('template[data-cmp-tpl="' + key + '"]');
    if (!tpl) return;
    var col = key.split('-')[0];
    tpl.content.querySelectorAll('[data-f]').forEach(function (src) {
      var cell = root.querySelector('[data-cmp-col="' + col + '"][data-f="' + src.getAttribute('data-f') + '"]');
      if (cell) cell.innerHTML = src.innerHTML;
    });
    btn.parentNode.querySelectorAll('[data-cmp-sw]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function init(root) {
    if (root.dataset.cmpReady) return;
    root.dataset.cmpReady = '1';
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cmp-sw]');
      if (btn) swap(root, btn);
    });
  }

  function boot() {
    document.querySelectorAll('[data-ch-compare]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
